export const SEARCHBOX_KEY: string = "searchbox-transfers-search";
export const T_CLI: string = "shopping-ds-it";
export const CROSS_SELLING_COUPON_COOKIE_NAME: string = 'pig-coupon-active';
export const BEST_TACTIC_DISCOUNTS: string = 'BEST_TACTIC_DISCOUNTS';
export const X_PREFERRED_CURRENCY_CODE_COOKIE: string = 'X-Preferred-Currency-Code';